function fold(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/** Client filter over identities already returned by GET /admin/identities. */
export function identityMatchesQuery(user, query) {
  const needle = fold(query);
  if (!needle) return true;
  const fox = user?.foxline || {};
  const haystack = [
    user?.email,
    user?.name,
    fox.name,
    fox.first_name,
    fox.last_name,
    fox.employee_code,
    fox.email,
  ];
  return haystack.some((part) => fold(part).includes(needle));
}
